import AlumniSearch from './AlumniSearch';

export default AlumniSearch;
